import React, { SVGAttributes } from 'react';

import styled from '@tanium/react-emotion-9';
import { flexbox, flexboxStylePropNames, FlexboxStyleProps } from '@tanium/style-system';

const StyledSvg = styled('svg', {
  shouldForwardProp: (p) => p !== 'innerRef' && !flexboxStylePropNames.includes(p as keyof FlexboxStyleProps),
})<FlexboxStyleProps>(flexbox);

export type SVGProps = SVGAttributes<SVGSVGElement> & FlexboxStyleProps;

/**
 * A wrapper around an SVG element.
 */
export const Svg = React.forwardRef<SVGSVGElement, SVGProps>((props, ref) => <StyledSvg innerRef={ref} {...props} />);
